import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'

import FaFrown from 'react-icons/fa/frown-o'

@autobind
class WorkCommentFlag extends Component {
  constructor (props) {
    super(props)
  }

  flagComment () {
    let confirm = window.confirm('You are flagging this comment for review by our support team. This will be removed from Pobble for all users instantly unless restored by support.')
    if (confirm) {
      API.put(`/v3/comments/${this.props.comment.id}/flag?include=comment.flag.data,comment.flag.account`)
        .then(response => this.props.onCommmentFlag(this.props.index))
        .catch(err => err.response.data.status == 400 && alert('Thanks for helping us to keep Pobble safe. We noticed that you are flagging quite a few things. Please get in touch via hello@pobble.com so we can address your concern.'))
    }
  }

  render () {
    return (
      <span className='comment__flag' onClick={this.flagComment}>
        <FaFrown />
      </span>
    )
  }
}

WorkCommentFlag.propTypes = {
  comment: PropTypes.object,
  index: PropTypes.number,
  onCommmentFlag: PropTypes.func
}

export default WorkCommentFlag



// WEBPACK FOOTER //
// ./components/work/WorkCommentFlag.js